import React from 'react';

import { Banner } from './Banner/Banner';
import styles from './LandingPage.scss';
import { Steps } from './Steps/Steps';
import useSessionLogger from './hooks/useSessionLogger';

const LandingPage: React.FC = () => {
  const errorCode = useSessionLogger();

  return (
    <div className={styles.landingPage}>
      <Banner errorCode={errorCode} />
      <Steps />
    </div>
  );
};
export default LandingPage;
